// extracted by mini-css-extract-plugin
export default {"left_box":"index_left_box_S-9Nw","dbox":"index_dbox_QgUVW","adBox":"index_adBox_FtZwF"};